import Vue from 'vue'
//因为是全局的一个'仓库'，所以初始化要在全局初始化
const eventBus = new Vue()

export default eventBus;